<template>
    <div class="attendance-table-wrapper card card-body">
        <div class="mb-3">
        <label>{{ $t("calendar.select_month") }}</label>
        <input type="month" class="form-control w-auto" v-model="selectedMonth" @change="loadCalendar" />
        </div>

        <div class="table-responsive attendance-table-scroll">
        <table class="table table-bordered text-center align-middle">
            <thead class="table-light sticky-top">
            <tr>
                <th class="sticky-col sticky-col-1">#</th>
                <th class="sticky-col sticky-col-2" style="min-width: 200px;">{{ $t("payroll.master.name_of_emp") }}</th>
                <th v-for="(day, index) in calendarHeaders" :key="index" style="min-width: 90px;">
                {{ $i18n.locale === 'ar' ? day.weekday_ar : day.weekday_en }}
                <br />
                {{ moment(day.date).format('D') }}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(emp, index) in employees" :key="emp.id">
                <td class="sticky-col sticky-col-1">{{ index + 1 }}</td>
                <td class="fw-bold text-start sticky-col sticky-col-2" style="min-width: 200px;">
                {{ emp.name }}
                </td>
                <td
                style="height: 90px;"
                v-for="(day, index) in emp.calendar"
                :key="index"
                :class="getStatusClass(day.status)"
                class="text-white p-1"
                @click="showDayDetail(day)"
                :title="`${emp.name} - ${$t('calendar.attendance.' + day.status)}`"
                >
                {{ $t('calendar.attendance.' + day.status) }}
                </td>
            </tr>
            </tbody>
            <tfoot>
            <tr class="bg-light text-center fw-bold">
                <td class="sticky-col sticky-col-1 bg-white" colspan="2">{{ $t("calendar.summary") }}</td>
                <td
                v-for="day in calendarHeaders"
                :key="day.date"
                class="bar-cell"
                >
                <div class="bar-wrapper">
                    <div
                    v-for="status in statusList"
                    :key="status"
                    class="bar-vertical"
                    :class="'bar-' + status"
                    :style="{ height: getBarHeight(day.date, status) + '%'}"
                    :title="$t('calendar.attendance.' + status) + ': ' + countStatus(day.date, status)"
                    ></div>
                </div>
                </td>
            </tr>
            </tfoot>
        </table>
        </div>

        <!-- Legend -->
        <div class="legend mt-4 d-flex flex-wrap justify-content-center">
        <div v-for="(label, key) in legend" :key="key" class="legend-item d-flex align-items-center m-2">
            <span :class="['legend-color', getStatusClass(key)]"></span>
            <span class="ms-2">{{ $t("calendar.attendance." + key) }}</span>
        </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Swal from 'sweetalert2';

export default {
    props: {
        activate_calendar_attendance: Object,
    },
    data() {
        return {
        selectedMonth: moment().format('YYYY-MM'),
        employees: [],
        calendarHeaders: [],
        legend: {
            attended: '',
            absent: '',
            not_schedule: '',
            holiday: '',
            legal_leave: '',
            illegal_leave: '',
            not_employed: ''
        },
        statusList: [
        'attended',
        'absent',
        'legal_leave',
        'illegal_leave',
        'holiday',
        'not_schedule',
        'not_employed'
        ]
        };
    },
    computed: {
        totalEmployees() {
            return this.employees.length;
        }
    },
    methods: {
        async loadCalendar() {
        const [year, month] = this.selectedMonth.split('-');
        const res = await this.http.post('emps/get-attendace-calendar', {
            year: parseInt(year),
            month: parseInt(month)
        });
        if (res.status) {
            this.employees = res.emps;
            this.calendarHeaders = res.table_headers;
            console.log('empl', this.employees, this.calendarHeaders)
        }
        },
        getStatusClass(status) {
        return {
            attended: 'bg-success',
            absent: 'bg-danger',
            not_schedule: 'bg-secondary',
            holiday: 'bg-info text-white',
            legal_leave: 'bg-warning text-dark',
            illegal_leave: 'bg-dark text-white',
            not_employed: 'bg-light text-muted'
        }[status] || '';
        },
        showDayDetail(day) {
        if (day.leave) {
            Swal.fire({
            title: day.leave.name,
            html: day.leave.descr,
            icon: 'info'
            });
        } else if (day.holiday) {
            Swal.fire({
            title: day.holiday.name,
            text: `${day.holiday.start_date} - ${day.holiday.end_date}`,
            icon: 'info'
            });
        }
        },
        countStatus(date, status) {
            return this.employees.filter(emp =>
              Array.isArray(emp.calendar) &&
              emp.calendar.find(day => day.date === date && day.status === status)
            ).length;
        },
        getBarHeight(date, status) {
            const count = this.countStatus(date, status);
            return this.totalEmployees > 0 ? (count / this.totalEmployees) * 100 : 0;
        }
    },
    mounted() {
        this.loadCalendar();
        // eslint-disable-next-line vue/no-mutating-props
        this.activate_calendar_attendance.loadCalendar = this.loadCalendar;
    }
};
</script>

<style scoped>
    .sticky-col {
    position: sticky;
    z-index: 2;
    background: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    }

    /* Assign left offsets based on cumulative widths */
    .sticky-col-1 {
    left: 0;
    min-width: 40px;
    }

    .sticky-col-2 {
    left: 40px;
    }
    .attendance-table-scroll {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
    border: 1px solid #dee2e6;
    }
    .attendance-table-scroll table {
    min-width: 1000px;
    border-collapse: collapse;
    }
    .legend-color {
    width: 20px;
    height: 20px;
    display: inline-block;
    border-radius: 4px;
    border: 1px solid #ccc;
    }
    .bg-success {
    background-color: #198754 !important;
    }
    .bg-danger {
    background-color: #dc3545 !important;
    }
    .bg-secondary {
    background-color: #6c757d !important;
    }
    .bg-warning {
    background-color: #ffc107 !important;
    }
    .bg-info {
    background-color: #0dcaf0 !important;
    }
    .bg-dark {
    background-color: #212529 !important;
    }
    .bg-light {
    background-color: #f8f9fa !important;
    }
    .bar-cell {
    height: 60px;
    padding: 0;
    vertical-align: bottom;
    }

    .bar-wrapper {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 100%;
    width: 100%;
    gap: 2px;
    }

    .bar-vertical {
    width: 9px;
    border-radius: 2px 2px 0 0;
    transition: height 0.3s ease;
    }

    .bar-attended {
    background-color: #198754;
    }

    .bar-absent {
    background-color: #dc3545;
    }

    .bar-legal_leave {
    background-color: #ffc107;
    }

    .bar-illegal_leave {
    background-color: #212529;
    }

    .bar-holiday {
    background-color: #0dcaf0;
    }

    .bar-not_schedule {
    background-color: #6c757d;
    }

    .bar-not_employed {
    background-color: #f8f9fa;
    }
</style>
